import { compose } from 'recompose';

import Row from './row';
import withOnline from '../../../utils/enchancers/withOnline';

const enhance = compose(
  withOnline,
);
export default enhance(Row);
